export default "__VITE_ASSET__BpyfjoX$__"